import { Loader2, X } from 'lucide-react';
import { attachmentUrl } from '../api/attachment';
import { useComposerStaging } from './ComposerStagingContext';
import { useT } from '../I18nContext';

/**
 * Small preview tile shown above the composer textarea when an
 * attachment is staged. Thumb + filename + status line + remove
 * button. Mirrors the legacy `#attachment-preview` element.
 *
 * Renders nothing while idle (no staged attachment).
 */
export function AttachmentStaging() {
  const { staged, status, errorMessage, clear } = useComposerStaging();
  const t = useT();

  // Error tile - staged is null but errorMessage is set.
  if (!staged && errorMessage) {
    return (
      <div className="attachment-staging attachment-staging-error" role="alert">
        <div className="attachment-staging-meta">
          <div className="attachment-staging-status">{errorMessage}</div>
        </div>
        <button
          type="button"
          className="attachment-staging-remove"
          onClick={clear}
          aria-label={t('attach.dismiss_error')}
        >
          <X size={14} />
        </button>
      </div>
    );
  }

  if (!staged && status === 'uploading') {
    return (
      <div className="attachment-staging">
        <div className="attachment-staging-thumb attachment-staging-thumb-loading">
          <Loader2 size={20} className="attachment-staging-spinner" />
        </div>
        <div className="attachment-staging-meta">
          <div className="attachment-staging-name">{t('attach.uploading')}</div>
        </div>
      </div>
    );
  }

  if (!staged) return null;

  return (
    <div className="attachment-staging">
      <img
        className="attachment-staging-thumb"
        src={attachmentUrl(staged.meta.id)}
        alt=""
      />
      <div className="attachment-staging-meta">
        <div className="attachment-staging-name">{staged.displayName}</div>
        <div className="attachment-staging-status">
          {status === 'uploading' ? t('attach.uploading') : t('attach.ready')}
        </div>
      </div>
      <button
        type="button"
        className="attachment-staging-remove"
        onClick={clear}
        aria-label={t('attach.remove')}
      >
        <X size={14} />
      </button>
    </div>
  );
}
